import React from 'react';
import { Music } from 'lucide-react';
import StarIcon from '../assets/images/icons/start-icon.svg';

const DummyTrackCard = ({
    trackData = {},
    isPro = false,
    onProClick = () => {},
}) => {
    const {
        image = null,
        name = 'Track Name',
        artist = 'Artist Name',
        date = '2024-01-01',
        label = 'Label Name',
        channel = 'Channel',
        icon = null
    } = trackData;

    return (
        <div className="relative w-full">
            {/* Original Track Card Content */}
            <div className="flex justify-between w-full bg-gray-50 transition-colors cursor-pointer mb-2">
                <div className="flex flex-1 flex-wrap gap-2">
                    <div className="w-20 bg-gray-200">
                        {image ? (
                            <img
                                src={image}
                                alt={name}
                                className="w-full h-full object-cover"
                            />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center">
                                <Music className="w-8 h-8 text-gray-400" />
                            </div>
                        )}
                    </div>
                    <div className="flex flex-1 flex-col">
                        <span className="font-medium text-gray-900 pt-1">
                            {name}
                        </span>
                        <span className="text-sm text-gray-500">
                            {artist}
                        </span>
                        <div className="flex flex-wrap justify-between items-center pb-1">
                            <div className="justify-start text-sm text-gray-600">
                                {date}
                            </div>
                            <div className="flex items-center gap-2 pr-2 w-full">
                                <span className="flex-1 text-sm text-gray-700">
                                    {label}
                                </span>
                                <span className="text-sm font-medium text-blue-500">
                                    {channel}
                                </span>
                                {icon && (
                                    <span>
                                        <img
                                            src={icon}
                                            alt={name}
                                            className="min-w-[25px] min-h-[25px] h-[25px] w-[25px]"
                                        />
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Pro Overlay (only shown when isPro is false) */}
            {!isPro && (
                <>
                    {/* Greyed Out Overlay */}
                    <div className="absolute inset-0 bg-gray-200/60 backdrop-blur-[1px] z-10" />

                    {/* Go Pro Button */}
                    <div className="absolute inset-0 z-20 flex items-center justify-center">
                        <button
                            type="button"
                            className={`btn-custom3 flex items-center gap-2`}
                            onClick={onProClick}
                        >
                            Go Pro
                            <img
                                src={StarIcon}
                                alt="Star"
                                className="h-[20px] w-[20px] min-w-[20px]"
                            />
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default DummyTrackCard